import { combineReducers } from 'redux';
import students from './student.reducer';
import student_events from './student_event.reducer'

const studentAppReducer = combineReducers({
    students,
    student_events

});

export default studentAppReducer;


// WEBPACK FOOTER //
// src/main/content/student/store/reducers/index.js